<template>
  <ContainerLayout class="tw:flex-col tw:lg:flex-1 tw:lg:self-stretch">
    <div class="tw:mr-auto tw:ml-auto tw:pt-2 tw:md:pt-6 tw:pb-6 tw:w-full tw:lg:flex tw:lg:flex-col tw:lg:flex-1">
      <RateCheckContainer />
    </div>
  </ContainerLayout>
</template>

<script setup lang="ts">
import RateCheckContainer from '@/components/rateConnect/rateCheck/RateCheckContainer.vue'
import ContainerLayout from '@/layouts/ContainerLayout.vue'
</script>
